import React from "react";
import styles from "./WebsiteInput.module.css";
import { useField, useFormikContext } from "formik";
import {
  FormField,
  SystemIcon,
  TextInput as MiloInput,
} from "@justworkshr/milo-components";
interface IWebsiteInputProps {
  name: string;
  label: string;
  message?: string;
  placeholder?: string;
  type?: string;
  required?: boolean;
  onDelete: () => void;
  fieldRefs?: React.MutableRefObject<{
    [key: string]: HTMLInputElement | null;
  }>;
}

const WebsiteInput = ({ ...props }: IWebsiteInputProps): JSX.Element => {
  const {
    name,
    label,
    placeholder,
    type,
    message,
    required = true,
    onDelete,
    fieldRefs,
  } = props;
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  return (
    <div className={styles.container}>
      <FormField
        required={required}
        message={message}
        label={label}
        error={meta.touched ? meta.error : ""}
      >
        <div className={styles.inputDiv}>
          <div className={styles.textInput}>
            <MiloInput
              data-testid={name}
              id={name}
              placeholder={placeholder}
              type={type}
              ref={(el) => {
                if (fieldRefs?.current) {
                  fieldRefs.current[name] = el as HTMLInputElement | null;
                }
              }}
              {...field}
              onBlur={(e) => {
                field.onBlur(e); // Call formik onBlur to trigger validations
                setFieldValue(name, e.target.value.trim());
              }}
            />
          </div>
          <SystemIcon
            iconName="trash"
            color="error"
            title="trash"
            size="small"
            className={styles.trashsvg}
            onClick={onDelete}
            data-testid={`trash-${name}`}
          />
        </div>
      </FormField>
    </div>
  );
};

export default WebsiteInput;
